import { Nemesis } from '../../../../aer-types/types'

export const nemeses: Nemesis[] = [
  {
    expansion: 'SD',
    name: 'The Wailing',
    id: 'TheWailing',
    health: 50,
    difficulty: 6,
    expeditionRating: 3,
    additionalInfo: '',
  },
]
